// extracted by mini-css-extract-plugin
export default {"container":"styles_container__g-qW8","close":"styles_close__h1NqO","closeIcon":"styles_closeIcon__Wr0r8","content":"styles_content__hgBFM"};